// import APIs
import { createDutyLine } from 'RestAPIs/employees/hours-table';

// import components
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

// import external libraries
import { useMutation, useQueryClient } from 'react-query';

// import types
import { CreateDutyLineMutateParams } from './useCreateDutyLine.types';

const useCreateDutyLine = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (params: CreateDutyLineMutateParams) => createDutyLine(params),

    {
      onSuccess: (_data, { employeeId }) => {
        queryClient.invalidateQueries(['hoursTable', employeeId]);
        showSuccessSnackbar();
      },
      onError: showErrorSnackbar
    }
  );
};

export default useCreateDutyLine;
